import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/new_inspection/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}/container/${container_id}`
    );
  },
  fetchExportedBatches({ container_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/new_inspection/container/${container_id}/exported_batches`
    );
  },
  fetchTemplate({ container_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/new_inspection/container/${container_id}/quality_template/${quality_template_id}`
    );
  },
  fetchInspectors(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/new_inspection/fetch_inspectors/${agro_exporter_process_id}`
    );
  },
  createWithSamplings({
    container_id,
    quality_template_id,
    registered_at,
    exported_batch_id,
    samplings,
    observations,
    inspect_code,
    inspector_id,
    quality_samplings
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/container/new_inspection/container/${container_id}/quality_template/${quality_template_id}/create`,
      {
        quality_inspect: {
          inspect_code,
          registered_at,
          samplings,
          observations,
          inspector_id
        },
        exported_batch_id,
        quality_samplings
      }
    );
  },
  createWithoutSamplings({
    container_id,
    quality_template_id,
    registered_at,
    observations,
    inspect_code,
    inspector_id,
    exported_batch_id,
    quality_generals
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/container/new_inspection/container/${container_id}/quality_template/${quality_template_id}/create_without_samplings`,
      {
        quality_inspect: {
          inspect_code,
          registered_at,
          observations,
          inspector_id
        },
        exported_batch_id,
        quality_generals
      }
    );
  }
};
